import { useCallback, useState } from 'react'
import styled from 'styled-components'
import { Card, Button, message, Input } from 'antd'
import { FirebaseApp } from 'firebase/app'
import { isEmpty } from 'lodash'
import { FirebaseSessionKey, isMobile } from '../constants'
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
  updateDoc,
  doc,
  addDoc,
} from 'firebase/firestore/lite'

type Props = {
  firebaseApp: FirebaseApp
  changeNavigation: ({ key }: { key: string }) => void
  setUserHasBilling: (value?: boolean) => void
}

const Promocodes = ({
  firebaseApp,
  changeNavigation,
  setUserHasBilling,
}: Props) => {
  const currentUser = JSON.parse(
    window.sessionStorage.getItem(FirebaseSessionKey) as string
  )
  const [promoCode, setPromoCode] = useState('')

  const promocodeCall = useCallback(
    async (code: string) => {
      const db = getFirestore(firebaseApp)
      const citiesCol = collection(db, 'promocodes')
      const q = query(citiesCol, where('promocode', '==', code))
      const querySnapshot = await getDocs(q)
      const eventList = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }))
      return eventList[0]
    },
    [firebaseApp]
  )

  const makePromocodeGet = useCallback(() => {
    if (isEmpty(promoCode)) {
      message.error('Insira um Promocodo')
      return
    }

    promocodeCall(promoCode).then(async (data: any) => {
      if (!data) {
        message.error('Promocode inválido')
        return
      }

      if (data && data.used) {
        message.error('Este promocode já foi utilizado')
        return
      }

      const db = getFirestore(firebaseApp)
      const { uid, displayName, email } = currentUser
      await updateDoc(doc(db, 'promocodes', data.id), {
        ...data,
        used: true,
        used_by: { uid, displayName, email },
      })
      const docRef = await addDoc(collection(db, 'billing'), {
        billing_start: new Date(),
        user_uid: uid,
        user_email: email,
      })

      if (docRef.id) {
        setUserHasBilling(undefined)
        changeNavigation({ key: '2' })
        message.success('Promocode inserido!')
      } else {
        message.error(
          'Ocorreu um problema, não conseguimos validar o promocode.'
        )
      }
    })
  }, [
    changeNavigation,
    currentUser,
    firebaseApp,
    promoCode,
    promocodeCall,
    setUserHasBilling,
  ])

  /*const handlePaymentSubmit = async () => {


    if (response.error) {
      message.error(response.error.message)
    } else if (response.paymentIntent.status === 'succeeded') {
      const db = getFirestore(firebaseApp)
      const docRef = await addDoc(collection(db, 'billing'), {
        billing_start: new Date(),
        user_uid: currentUser.uid,
      })

      if (docRef.id) {
        makePaymentsGet()
        message.success('Pagamento efectuado com sucesso!')
      } else {
        message.error(
          'Ocorreu um problema, não conseguimos validar o pagamento.'
        )
      }
    } else {
      message.error('Ocorreu um problema, não conseguimos validar o pagamento.')
    }
  }*/

  return (
    <Container>
      <Card
        type="inner"
        title={
          <p style={{ fontWeight: 'bold', margin: '0', fontSize: '16px' }}>
            Promocode:
          </p>
        }
        style={{
          marginBottom: '15px',
          fontWeight: 'bold',
          width: isMobile ? '100%' : '800px',
        }}
      >
        <p>Tens um PROMOCODE? Insere aqui:</p>
        <Input
          size="middle"
          value={promoCode}
          placeholder={'Promocode'}
          onChange={(e) => setPromoCode(String(e.target.value))}
        />
        <Button
          type="primary"
          onClick={() => makePromocodeGet()}
          style={{ marginTop: '20px' }}
        >
          Validar
        </Button>
      </Card>
    </Container>
  )
}

export default Promocodes

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 50px;

  @media (max-width: 768px) {
    padding: 5px;
  }
`
